var Raphael = require('raphael'),
    SVGNote = require('./base'),
    TextShapeView = require('../../../../../../canvas/views/shape/graphic/text/text'),
    GraphicShapeView = require('../../../../../../canvas/views/shape/graphic/graphic'),
    FDDGraphicNote = require('../../fddGraphicNote'),
    GraphicShapeModel = require('../../../../../../canvas/models/graphic'),
    fvChannel = require('glRadio').channel('FV');

module.exports = SVGNote.extend({

    SUPPORTS_COLOR_PICKER: 1,

    ShapeModel: GraphicShapeModel,
    init: 'V',
    createHotKey: 'g',
    desc: FDDGraphicNote.prototype.desc,
    iconClass: FDDGraphicNote.prototype.iconClass,
    actionTitle: 'Draw',
    defaultSubType: 'free',

    /**
     * defaultShapeColor:
     *  DVBC-1779: INSCOM wants black -- was:
     *  #0064CD, blue, like the note view color from SVG graphic notes
     *  this should change when define attributes at the shape level
     *  or at least come from central setting file -- in case needs to be overwritten
     */
    defaultShapeColor: '#000000',
    defaultStrokeWidth: 2, // stroke width to apply to newly drawn shapes

    subTypes: ['free', 'rect-fill', 'rect-nofill', 'line', 'line-dashed', 'line-arrow', 'text'], // could have another level-- sub-sub type
    DEFAULT_FILL_OPACITY: {
        'fill-opacity': 0.25 // (it's lighter than the stroke)
    },
    getNoteClass: function() {
       return FDDGraphicNote.prototype.getNoteClass(1);
    },
    getIconHoverLbl: function() {
        return FDDGraphicNote.prototype.getIconHoverLbl(1);
    },
    shapeView: function(options) {

        // This needs review
        // Really need to stop deriving the shape models !
        var sm = options.shapeModel,
            preExisting = sm.uiModel.get('raphaelEl') === null && sm.origSVGAttrs !== undefined, //(existed on canvas render)
            shapeType = preExisting
                ? sm.determineGraphicNoteShapeSubType( sm.origSVGAttrs )
                : sm.deriveShapeSubType();

        switch(shapeType) {
            case 'text':
                return new TextShapeView(options);
            default:
                return new GraphicShapeView(options);
        }

    },

    /**
     * Probably best to always store the subtype on the shape
     */
    defaultSVGAttrsEdit: function( color, noteSubType, currentDrawingAttrs ) {

        // Hack! NEED TO OVERRIDE CURRENT DRAWING ATTRIBUTE COLOR WITH 'OVERRIDE COLOR'
        currentDrawingAttrs.color = color;

        var attrs = this._getBaseSVGAttributes( currentDrawingAttrs );

        switch( noteSubType ) {

            case 'rect-nofill':
                attrs['fill-opacity'] = 0; //alter the opacity to 0 -- its see through but mouseover will still work
                _.extend( attrs, {'stroke-linejoin': 'miter'} );
                break;

            case 'line':
                attrs = _.omit(attrs, 'fill-opacity');
                break;

            case 'line-dashed':
                attrs = _.omit(attrs, 'fill', 'fill-opacity');
                _.extend( attrs, {'stroke-dasharray': '- '} );
                break;

            case 'line-arrow':
                attrs = _.omit(attrs, 'fill', 'fill-opacity');
                _.extend( attrs, {'arrow-end': 'block-wide-long'} );
                break;

            case 'free':
                attrs = _.omit(attrs, 'fill', 'fill-opacity');
                _.extend( attrs, {'stroke-linejoin': 'round'} );
                break;

            case 'rect-fill': //nothing for now
                _.extend( attrs, {'stroke-linejoin': 'miter'} );
                break;

            case 'text':
                attrs = { // this would be for the text-area, which is then later applied to the svg shape
                    color: attrs.color
                };
                break;
        }

        return attrs;

    },

    _getBaseSVGAttributes: function( currentDrawingAttrs ) {

        var o = _.pick( currentDrawingAttrs , 'stroke-width'),
            color = currentDrawingAttrs.color; // applicable to stroke & fill

        _.extend( o, {
            stroke: color,
            fill: color
        }, this.DEFAULT_FILL_OPACITY );

        return o;

    },

    getDefaultStrokeWidth: function() {
        return this.defaultStrokeWidth;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/graphic.js
 ** module id = 291
 ** module chunks = 0
 **/